import React, { useEffect, useState, useMemo, useCallback } from 'react';
import styles from './Overview.module.css';
import { CAMPAIGN_STATUS, CAMPAING_PROMISE_TYPES } from '../../../../constants/enums';
import { debugLog } from '../../../../utils/debugLogger';
import campaignValues from '../../../../utils/campaignValues';
const IMAGE_SOURCES = {
    COMPLETED: require('../../../../images/Icon_completed.png'),
    STARTS_IN: require('../../../../images/Icon_starts_in.png'),
    ONGOING: require('../../../../images/Icon_ongoing.png')
};

const Overview = (props) => {
    debugLog('prod promise', props.campaignPromiseType);

    const [hasNoPromise, setHasNoPromise] = useState('');
    const [isNonMOMSFollowUpCampaign, setIsNonMOMSFollowUpCampaign] = useState(false);
    useEffect(() => {
        setHasNoPromise(
            props.campaignPromiseType === CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE
        );
        
        setIsNonMOMSFollowUpCampaign(campaignValues.isNonMOMSFollowUpCampaign(props.campaignPromiseType));

    }, [props.campaignPromiseType]);

    const fetchCampaignStatus = (campaignStatus) => {
        if (campaignStatus === CAMPAIGN_STATUS.COMPLETED)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={styles.circle}>
                        <img
                            src={IMAGE_SOURCES.COMPLETED}
                            alt="Completed"
                            className={styles.circleImage}
                        />
                    </div>
                    <div className={styles.circleDescription}>Completed</div>
                </div>);
        else if (campaignStatus === CAMPAIGN_STATUS.ONGOING)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={styles.circle}>
                        <img
                            src={IMAGE_SOURCES.ONGOING}
                            alt="Ongoing"
                            className={styles.circleImage}
                        />
                    </div>
                    <div className={styles.circleDescription}>Ongoing</div>
                </div>);
        else
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={styles.circle}>
                        <img
                            src={IMAGE_SOURCES.STARTS_IN}
                            alt="StartsIn"
                            className={styles.circleImage}
                        />
                    </div>
                    <div className={styles.circleDescription}>Starts in {props.campaignStartsInDays} days</div>
                </div>);
    };

    const fetchProductPromise = (productPromise) => {
        if (hasNoPromise || isNonMOMSFollowUpCampaign) {
            return null;
        }
        return (
            <div className={styles.circleAndTextContainer}>
                <div className={`${styles.circleWithText} ${styles.productPromiseColor}`}>
                    <div className={styles.circleText}>{productPromise}</div>
                </div>
                <div className={styles.circleDescription}>Product Promise</div>
            </div>
        );
    };

    const fetchDeliveryStatus = (campaignStatus, isSuccessful, deliveryPercentage, campaignPromiseType) => {
        if (hasNoPromise) {
            return null;
        }
        if (campaignStatus === CAMPAIGN_STATUS.COMPLETED && isSuccessful)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={`${styles.circleWithText} ${styles.deliveredColor}`}>
                        <div className={styles.circleText}>{props.deliveryPercentage}%</div>
                    </div>
                    <div className={styles.circleDescription}>Delivered</div>
                </div>
            );
        else if (campaignStatus === CAMPAIGN_STATUS.COMPLETED && !isSuccessful)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={`${styles.circleWithText} ${styles.notDeliveredColor}`}>
                        <div className={styles.circleText}>{props.deliveryPercentage}%</div>
                    </div>
                    <div className={styles.circleDescription}>Not Delivered</div>
                </div>
            );
        else if (campaignStatus === CAMPAIGN_STATUS.NOT_STARTED && campaignPromiseType === CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={`${styles.circleWithText} ${styles.notCompletedColor}`}>
                        <div className={styles.circleText}>-</div>
                    </div>
                    <div className={styles.circleDescription}>Not started</div>
                </div>
            );
        else if (campaignStatus === CAMPAIGN_STATUS.ONGOING && campaignPromiseType === CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC)
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={`${styles.circleWithText} ${styles.notCompletedColor}`}>
                        <div className={styles.circleText}>-</div>
                    </div>
                    <div className={`${styles.circleDescription} ${styles.circleDescriptionMultiline}`}>
                        <span>Awaiting</span>
                        <span style={{ whiteSpace: 'nowrap' }}>Outdoor Impact</span>
                        <span>result</span>
                        <span className={styles.smallText}>(will be shown after <br></br> the end of the campaign)</span>
                    </div>
                </div>
            );
        else
            return (
                <div className={styles.circleAndTextContainer}>
                    <div className={`${styles.circleWithText} ${styles.notStartedColor}`}>
                        <div className={styles.circleText}>{props.deliveryPercentage}%</div>
                    </div>
                    <div className={styles.circleDescription}>Delivery %</div>
                </div>
            );
    };

    const visibleCircleCount =
        1 +
        (!hasNoPromise && !isNonMOMSFollowUpCampaign ? 1 : 0) +
        (!hasNoPromise ? 1 : 0);

    return (
        <div className={styles.resultOverviewContainer}>
            <div className={`${styles.circleContainer} ${styles[`cols${visibleCircleCount}`]}`}>
                {fetchProductPromise(props.productPromise)}
                {fetchCampaignStatus(props.campaignStatus)}
                {fetchDeliveryStatus(props.campaignStatus, props.isSuccessful, props.deliveryPercentage, props.campaignPromiseType)}
            </div>
        </div>
    );
};

export default Overview;